import Vue from 'vue';

// Vue imports
import ReviewForm from '../../shared/components/ReviewForm';
import SkinsChampionsSearch from './SkinsChampionsSearch.vue';
import Faq from './Faq.vue';
import FaqItem from './FaqItem.vue';
import FaqSearch from './FaqSearch.vue';
import SpellCarousel from './SpellCarousel.vue';
import CartButton from './CartButton.vue';
import CartSummary from './CartSummary.vue';
import Checkout from './Checkout.vue';
import AddToCartButton from './AddToCartButton.vue';
import ApplyCoupon from './ApplyCoupon.vue';
import ContactForm from './ContactForm.vue';
import RedeemModal from './RedeemModal.vue';
import BlogPage from './blog/BlogPage';
import FloatingButton from './blog/FloatingButton';
import SkindexPage from './skindex/SkindexPage';
import BlogSidebar from './BlogSidebar';
import DeferredVideo from './DeferredVideo';
import AvailableAccounts from './landingpage/AvailableAccounts';
import LandingStepPoint from './landingpage/LandingStepPoint';
import HowItWorks from './landingpage/HowItWorks';
import HowItWorksHorizontal from './landingpage/HowItWorksHorizontal';
import HowItWorksVertical from './landingpage/HowItWorksVertical';

Vue.component('review-form', ReviewForm);
Vue.component('skins-champions-search', SkinsChampionsSearch);
Vue.component('faq', Faq);
Vue.component('faq-item', FaqItem);
Vue.component('faq-search', FaqSearch);
Vue.component('spell-carousel', SpellCarousel);
Vue.component('cart-button', CartButton);
Vue.component('cart-summary', CartSummary);
Vue.component('checkout', Checkout);
Vue.component('add-to-cart-button', AddToCartButton);
Vue.component('apply-coupon', ApplyCoupon);
Vue.component('contact-form', ContactForm);
Vue.component('redeem-modal', RedeemModal);
Vue.component('blog-sidebar', BlogSidebar);
Vue.component('blog-page', BlogPage);
Vue.component('floating-button', FloatingButton);
Vue.component('skindex-page', SkindexPage);
Vue.component('deferred-video', DeferredVideo);
Vue.component('available-accounts', AvailableAccounts);
Vue.component('landing-step-point', LandingStepPoint);
Vue.component('how-it-works', HowItWorks);
Vue.component('how-it-works-horizontal', HowItWorksHorizontal);
Vue.component('how-it-works-vertical', HowItWorksVertical);

// React imports
import { autoInjectComponents } from '../utils/react-injector';
import { HighendsPage } from './highends/HighendsPage';
import { PackagesPage } from './packages/PackagesPage';
import { Valorant } from '../pages/Valorant/Valorant';
import { ValorantAccountPage } from '../pages/ValorantAccount/ValorantAccount';
import { AddStructuredData } from './packages/AddStructuredData';
import { PackageCard } from './packages/PackageCard';
import { NewsletterPopup } from './newsletter-popup';
import { Breadcrumb } from './packages/Breadcrumb'

export const renderAutoInjectableComponents = () =>
  autoInjectComponents({
    HighendsPage,
    PackagesPage,
    AddStructuredData,
    PackageCard,
    NewsletterPopup,
    Valorant,
    ValorantAccountPage,
    Breadcrumb
  });
